<template>
  <div class="box">
    <uni-popup ref="prescription" type="bottom">
      <uni-card
        title="处方笺"
        :middleTitle="
          getKeyValueText('prescrip_state', preDetail.state) +
          ' / ' +
          getKeyValueText('pay_state', preDetail.payState)
        "
        :prescriptState="preDetail.state"
        :is-full="true"
        note="true"
      >
        <scroll-view scroll-y class="show_wrap">
          <div class="state_wrap" />
          <uni-notice-bar
            v-show="preDetail.checkProposal"
            :text="'备注：' + preDetail.checkProposal"
          />
          <div class="title">
            <span>{{ doctor.hospitalName }}</span>
            <span>处方笺</span>
            <div v-if="preDetail.prescripClass === '1'" class="pre">
              <span>
                {{
                  getKeyValueText(
                    'prescrip_class',
                    preDetail.prescripClass ? preDetail.prescripClass : '1'
                  ).split('')[0]
                }}
              </span>
            </div>
            <div v-if="preDetail.prescripClass === '3'" class="green">
              <span>
                {{
                  getKeyValueText(
                    'prescrip_class',
                    preDetail.prescripClass ? preDetail.prescripClass : '1'
                  ).split('')[0]
                }}
              </span>
            </div>
            <div v-if="preDetail.prescripClass === '2'" class="yellow">
              <span>
                {{
                  getKeyValueText(
                    'prescrip_class',
                    preDetail.prescripClass ? preDetail.prescripClass : '1'
                  ).split('')[0]
                }}
              </span>
            </div>
          </div>
          <div class="sec_title">
            <span>No.{{ preDetail.prescripNum }}</span>
            <span class="self">
              <!-- ' ' 中间的空格不要去掉 就是这么写的 -->
              {{ getKeyValueText('patient_fee_type', preDetail.patientFeeType) || ' ' }}
            </span>
          </div>
          <div class="border_wrap" />
          <uni-card :is-full="true">
            <div class="prescrip-wrap">
              <div class="prescrip-msg">
                <span>
                  姓名：
                  <span>{{ preDetail.patientName }}</span>
                </span>
                <span>
                  性别：
                  <span>{{ preDetail.sex === '2' ? '女' : '男' }}</span>
                </span>
                <span>
                  年龄：
                  <span>{{ preDetail.age }}</span>
                </span>
              </div>
              <div class="prescrip-msg">
                <span>
                  咨询号：
                  <span>{{ visit || '' }}</span>
                </span>
                <span>
                  科室：
                  <span>{{ preDetail.deptName }}</span>
                </span>
              </div>
              <div class="prescrip-msg">
                <span>
                  日期：
                  <span>{{ preDetail.createTime }}</span>
                </span>
                <span>
                  手机号：
                  <span>{{ phone }}</span>
                </span>
              </div>
              <div class="row_wrap">
                <span class="diagnosis">诊断：</span>
                <div v-if="sysName" class="diagnosis_content">
                  <div v-for="(item, i) in sysList" :key="i" class="diagnose_wrap">
                    <span :class="item.symptomType === '3' ? 'meng_text' : 'symptom_text'">
                      {{ item.symptomName || '' }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="r_style">
              <span>R</span>
              <div
                v-if="preDetail.prescripType !== '7'"
                class="savePrivatePrescrip"
                @click="savePrivatePrescrip"
              >
                <span class="text">存私人处方</span>
              </div>
            </div>
            <ms-drug-show
              :drug-list="preDetail.prescripDrugsInfoList"
              :prescription="preDetail.patientName"
              :prescripType="preDetail.prescripType"
              :page="'处方笺'"
              :templateType="preDetail.templateType"
              :prescripTemplateNum="preDetail.prescripTemplateNum"
            />
            <div
              v-if="
                preDetail.prescripType === '3' ||
                preDetail.prescripType === '5' ||
                preDetail.prescripType === '6'
              "
            >
              <div class="blank_row">
                <span>------------------ 以下空白 ------------------</span>
              </div>
              <div class="prescrip-wrap usage_wrap">
                <div class="prescrip-msg">
                  <span>
                    剂数：
                    <span>{{ preDetail.doesNumber }}剂</span>
                  </span>
                  <div class="process_method">
                    <span>
                      {{ getKeyValueText('process_method', preDetail.processMethod) }}
                    </span>
                  </div>
                </div>
                <div class="prescrip-msg">
                  <span>
                    用法：
                    <span>
                      {{ getKeyValueText('chinese_drug_usage', preDetail.chineseDrugUsage) }}
                    </span>
                  </span>
                </div>
                <div class="prescrip-msg">
                  <span>
                    备注：
                    <span>{{ preDetail.prescripDesc || '' }}</span>
                  </span>
                </div>
              </div>
            </div>
            <div class="prescrip-wrap">
              <div
                v-if="['1', '2', '4', '7'].includes(preDetail.prescripType)"
                class="prescrip-msg"
              >
                <span>
                  金额：
                  <span>{{ preDetail.cost }}元</span>
                </span>
                <span>
                  自付：
                  <span>{{ preDetail.cost }}元</span>
                </span>
              </div>
              <div class="prescrip-msg">
                <span>
                  医生：
                  <span>
                    <!-- 草稿处方不显示医生签名 测试和产品确认后说的 -->
                    <!-- ' ' 中间的空格不要去掉 就是这么写的 -->
                    {{ preDetail.state === '0' ? ' ' : preDetail.doctorName || '' }}
                  </span>
                </span>
                <span>
                  审核：
                  <span>
                    {{ preDetail.state === '0' ? ' ' : preDetail.checkDoctorName || '' }}
                  </span>
                </span>
              </div>
              <div class="prescrip-msg">
                <span>
                  配药：
                  <span>{{ preDetail.deployDoctorName || '' }}</span>
                </span>
                <span>
                  发药：
                  <span>{{ preDetail.drugDispendName || '' }}</span>
                </span>
              </div>
              <div
                v-if="
                  preDetail.prescripType === '3' ||
                  preDetail.prescripType === '5' ||
                  preDetail.prescripType === '6'
                "
              >
                <div class="prescrip-msg">
                  <span>
                    药费：
                    <span>{{ preDetail.drugCharge }}</span>
                  </span>
                  <span>
                    煎药费：
                    <span>{{ preDetail.processCharge || '' }}</span>
                  </span>
                </div>
                <div class="prescrip-msg">
                  <span>
                    合计：
                    <span>{{ preDetail.cost || '' }}元</span>
                  </span>
                  <span>
                    自付：
                    <span>{{ preDetail.cost || '' }}元</span>
                  </span>
                </div>
              </div>
              <div class="validDays">
                <span>注：处方有效期{{ preDetail.validDays }}天</span>
              </div>
            </div>
          </uni-card>
        </scroll-view>
        <template v-slot:footer>
          <!-- 处方状态是已审核需要隐藏撤销和修改处方 金永新增 2022/05/16 又要求去掉隐藏 2022/05/17-->
          <div class="btn_wrap">
            <div class="footer-box cancel_btn" @click="cancelPrescrip">
              <span class="btn">撤销处方</span>
            </div>
            <div class="footer-box update_btn" @click="updatePrescrip">
              <span class="btn">修改处方</span>
            </div>
            <div class="footer-box" @click="copyPrescrip">
              <span class="btn">复制处方</span>
            </div>
          </div>
        </template>
        <template v-slot:close>
          <uni-icons type="closeempty" color="#666" @click="close" />
        </template>
      </uni-card>
    </uni-popup>
    <uni-popup ref="popup" class="popup-dialog-custom" type="dialog">
      <uni-popup-dialog
        type="info"
        mode="slot"
        :showConfirmButton="true"
        :before-close="true"
        confirmText="保存"
        cancelText="取消"
        @confirm="onConfirm"
        @close="closePopup"
      >
        <template>
          <uni-forms ref="form" v-model="formData" class="form-wrap" :rules="rules">
            <uni-forms-item class="uni-form-item" name="prescripName">
              <textarea
                ref="textareaWrap"
                v-model="formData.prescripName"
                class="my-textarea"
                placeholder="请输入处方名称"
                placeholder-style="color:#888;font-size:.64rem"
                placeholder-class="prescrip_name"
                @focus="binddata('prescripName', $event.detail.value)"
                @input="binddata('prescripName', $event.detail.value)"
                :show-confirm-bar="false"
              ></textarea>
            </uni-forms-item>
          </uni-forms>
        </template>
      </uni-popup-dialog>
    </uni-popup>
  </div>
</template>
<script>
import { getKeyValueText } from '@/views/funcPuzzle/utils/util.js'
import { mapState } from 'vuex'
import { addPrescripTemplate, fCancelPrescrip } from '@/views/funcPuzzle/utils/index.js'
import msDrugShow from '@/views/funcPuzzle/components/ms-drug-show/ms-drug-show.vue'

export default {
  components: {
    msDrugShow
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Array, String],
      default: () => {
        return []
      }
    },
    symptomName: {
      type: [Object, String],
      default: ''
    },
    patientPhone: {
      type: [Object, String],
      default: ''
    },
    visitNo: {
      type: [Object, String],
      default: ''
    },
    seletedIndex: {
      type: [Object, String, Number],
      default: ''
    },
    preLength: {
      type: [String, Number],
      default: () => {
        return 0
      }
    },
    visitRecordType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showAddDrug: false,
      preDetail: '',
      isHis: false,
      formData: {
        prescripName: ''
      },
      rules: {
        prescripName: {
          rules: [
            {
              required: true,
              errorMessage: '处方名称不能为空'
            }
          ],
          label: '',
          validateTrigger: 'submit'
        }
      }
    }
  },
  computed: {
    ...mapState(['doctor']),
    // preDetail:{
    //     get(){
    //         return this.prescripItem
    //     },
    //     set(val){
    //         this.$emit('update:prescripItem',val)
    //     }
    // },
    sysList() {
      return this.symptomName
    },
    sysName: {
      get() {
        return this.symptomName
      },
      set(val) {
        this.$emit('update:symptomName', val)
      }
    },
    phone: {
      get() {
        return this.patientPhone
      },
      set(val) {
        this.$emit('update:patientPhone', val)
      }
    },
    visit: {
      get() {
        return this.visitNo
      },
      set(val) {
        this.$emit('update:visitNo', val)
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.$refs.prescription.open()
      } else {
        this.close()
      }
    }
  },
  methods: {
    getKeyValueText,
    closePopup() {
      this.$refs.popup.close()
    },
    async onConfirm() {
      const { prescripName } = await this.$refs.form.validate()

      await addPrescripTemplate({
        hospitalID: this.preDetail.hospitalID,
        prescripName: prescripName,
        templateType: '1',
        diagnosis: { diagnosisList: JSON.stringify(this.sysList) },
        deptName: this.preDetail.deptName,
        doctorID: this.preDetail.doctorID,
        doctorName: this.preDetail.doctorName,
        prescripType: this.preDetail.prescripType,
        state: 1,
        warehouseID: this.preDetail.warehouseID,
        drugs: { drugList: this.preDetail.prescripDrugsInfoList }
      }).then(res => {
        if (!res.code) {
          uni.showToast({
            title: '处方添加成功',
            icon: 'none',
            duration: 2500
          })
        }
        // uni.showToast({
        //   title: res.code === 0 ? `处方添加成功` : res.codeDesc,
        //   icon: 'none',
        //   duration: 2500
        // })
        this.closePopup()
      })
    },
    // 存私人处方
    savePrivatePrescrip() {
      this.$refs.popup.open()

      if (['1', '2'].includes(this.visitRecordType)) {
        this.formData.prescripName = this.sysList
          .map(item => {
            return item.symptomName
          })
          .join('，')
      } else {
        this.formData.prescripName = ''
      }
    },
    close() {
      if (!this.$refs.prescription) {
        return false
      }
      this.$emit('update:visible', false)
      this.$refs.prescription.close()
      // if (this.isHis) {
      // }
    },
    createPrescrip() {
      this.close()
    },
    updatePrescrip() {
      console.log(this.preDetail, 'this.preDetail修改')
      this.$bus.emit('updatePrescrip', {
        val: this.preDetail,
        val2: this.seletedIndex
      })
      this.$refs.prescription.close()
    },
    copyPrescrip() {
      this.$bus.emit('copyPrescrip', {
        val: this.preDetail,
        val2: this.preLength
      })
      this.$refs.prescription.close()
    },
    cancelPrescrip() {
      fCancelPrescrip({
        id: this.preDetail.id
      }).then(rs => {
        if (rs.code == '0') {
          this.$refs.prescription.close()
          uni.showToast({
            title: rs.codeDesc,
            icon: 'none'
          })
        } else {
          // uni.showToast({
          //   title: rs.codeDesc,
          //   icon: 'none'
          // })
        }
      })
    },
    open() {
      this.$refs.prescription.open()
    }
  },
  mounted() {
    this.$bus.on('prescripDetail', detail => {
      this.preDetail = detail.preItem
      this.sysName = detail.symptomName

      this.phone = detail.patientPhone
      this.visit = detail.visitNo
      this.$refs.prescription.open()
    })
  },
  unmounted() {
    this.$bus.off('copyPrescrip')
    this.$bus.off('updatePrescrip')
    this.$bus.off('backToHis')
  }
}
</script>

<style lang="scss" scoped>
.show_wrap {
  display: flex;
  flex-direction: column;
  max-height: 19.2rem;
  // overflow-y: scroll;
  // padding: 0 .682667rem;
  // overflow-x: hidden;
  z-index: 1100;
  .state_wrap {
    padding: 0 0.682667rem 0 0.512rem;
    position: relative;
  }

  .title {
    height: 3.2rem;
    text-align: center;
    font-size: 0.768rem;
    font-weight: 500;
    color: #222222;
    line-height: 1.194667rem;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 0.426667rem;
    position: relative;
    font-family: PingFangSC-Medium, PingFang SC;
    .pre,
    .green,
    .yellow {
      width: 0.853333rem;
      height: 0.853333rem;
      border-radius: 0.085333rem;
      border: 0.021333rem solid #cecece;
      text-align: center;
      line-height: 0.853333rem;
      position: absolute;
      top: 0;
      right: 0.426667rem;
      margin-top: 0.213333rem;
    }
    .green {
      color: #4fe1a7;
      border: 0.021333rem solid #4fe1a7;
    }
    .yellow {
      color: #ffc47e;
      border: 0.021333rem solid #ffc47e;
    }
  }
  .sec_title {
    width: 16rem !important;
    // margin-left: -0.682667rem;
    border-bottom: 0.021333rem solid #ececec;
    display: flex;
    justify-content: space-between;
    font-size: 0.64rem;
    font-weight: 400;
    color: #222222;
    line-height: 1.28rem;
    padding: 0 0.682667rem 0.426667rem 0.682667rem;
    box-sizing: border-box;
  }
  .border_wrap {
    width: 16rem;
    height: 0.042667rem;
    .border_wrap::after {
      width: 1.2rem;
      height: 1rem;
      background-color: #ececec;
    }
  }
  .r_style {
    font-size: 1.28rem;
    font-weight: 400;
    color: #222222;
    padding: 0 0.682667rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .savePrivatePrescrip {
      width: 3.157333rem;
      height: 1.024rem;
      border-radius: 0.085333rem;
      border: 0.021333rem solid #0089ff;
      padding: 0.256rem;
      box-sizing: border-box;
      line-height: 0;
      .text {
        font-size: 0.512rem;
        font-weight: 400;
        color: #0089ff;
        line-height: 1;
      }
    }
  }
  .blank_row {
    height: 3.285333rem;
    line-height: 3.285333rem;
    text-align: center;
    color: #888;
    font-size: 0.512rem;
  }
  .prescrip-wrap {
    height: auto;
    padding: 0.64rem 0.682667rem 0.682667rem 0.682667rem;
    border-bottom: 0.021333rem solid #ececec;
    width: 16rem !important;
    // margin-left: -0.682667rem;
    border-bottom: 0.021333rem solid #ececec;
    box-sizing: border-box;

    .prescrip-msg {
      display: flex;
      margin-bottom: 0.853333rem;
      text {
        flex: 1;
        font-size: 0.64rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #888;
        line-height: 0.853333rem;
        text:first-child {
          color: #222;
        }
      }
    }
    .validDays {
      color: #ff7555 !important;
      font-size: 0.512rem;
      font-weight: 400;
    }
    .row_wrap {
      width: 100%;
      min-height: 1.92rem;
      position: relative;
      display: flex;
      box-sizing: border-box;
      .diagnosis_content {
        display: flex;
        flex-wrap: wrap;
        .diagnose_wrap {
          width: auto;
          font-size: 0.512rem;
          font-weight: 400;
          color: #222222;
          line-height: 0.682667rem;
          height: 0.682667rem;
          background: #eee;
          padding: 0.085333rem 0.256rem;
          margin: 0 0.512rem 0.426667rem 0;
          .symptom_text {
            font-family: PingFangSC-Regular, PingFang SC !important;
          }
          .meng_text {
            font-family: PingFang-SC-Medium, PingFang SC, Menksoft Budun !important;
          }
        }
      }
      .diagnosis {
        font-size: 0.64rem;
        font-weight: 400;
        color: #888;
        line-height: 0.853333rem;
        min-width: 2.133333rem !important;
      }
      .addDrug {
        color: #0089ff;
        font-size: 0.597333rem;
        position: absolute;
        right: 0.64rem;
      }
    }
  }
  .usage_wrap {
    // height: 4.266667rem;
    .process_method {
      width: 1.450667rem;
      height: 0.853333rem;
      background: #eeeeee;
      border-radius: 0.085333rem;
      text-align: center;
      line-height: 0.853333rem;
      color: #222;
      font-size: 0.512rem;
    }
  }
}
.btn_wrap {
  display: flex;
  justify-content: space-between;
}
.footer-box,
.update_btn {
  text-align: center;
  width: 4.416rem;
  height: 1.877333rem;
  line-height: 1.877333rem;
  border-radius: 0.938667rem;
  font-size: 0.682667rem;
  // margin-right: .682667rem;
}
.footer-box {
  background: #0089ff;
  color: #fff;
}
.update_btn {
  border: 0.021333rem solid #0089ff;
  background-color: #fff;
  color: #0089ff;
}
.cancel_btn {
  border: 0.021333rem solid #ececec;
  color: #222;
  background-color: #fff;
}
</style>
<style lang="scss" scoped>
.form-wrap {
  flex: 1;
  ::v-deep .uni-forms-item {
    border: none;
    .uni-error-message {
      bottom: -0.597333rem;
    }
  }
  ::v-deep .prescrip_name {
    color: #888 !important;
    font-size: 0.64rem;
  }
  .uni-form-item {
    padding-top: 0;
    display: block;
    border: none;

    .my-textarea {
      position: static;
      flex: 1;
      height: 3.328rem;
      width: 100%;
      overflow: auto;
    }
  }
}
::v-deep .popup-dialog-custom {
  .uni-popup-dialog {
    width: 13.653333rem;
    .uni-dialog-title {
      padding: 1.813333rem 0.96rem 0.682667rem;
      justify-content: flex-start;
      .uni-dialog-title-text {
        position: relative;
        font-size: 0.768rem;
        line-height: 0.768rem;
        text-align: left;
        color: #222222;
        z-index: 20;
      }
    }
    .uni-dialog-content {
      padding-left: 0.96rem;
      padding-right: 0.96rem;
      height: 3.328rem;
    }
    .uni-dialog-button-group {
      .uni-dialog-button {
        padding-top: 0.810667rem;
        padding-bottom: 0.853333rem;
        height: auto;
        .uni-dialog-button-text {
          font-size: 0.682667rem;
          line-height: 0.682667rem;
        }
      }
    }
  }
}
::v-deep .uni-forms-item__content {
  padding-right: 0 !important;
}
</style>
